module.exports = __webpack_public_path__ + "img/australia.b35a142d.svg";